import { API_BASE_URL } from "src/config/apiBase";
import React from "react";
import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";

const BlogImageSlider = ({ images }) => {
  const url = API_BASE_URL
  const [sliderRef, instanceRef] = useKeenSlider({
    loop: true,
    slides: { perView: 1, spacing: 10 },
    mode: "snap",
  });
console.log(images);
  return (
    <div className="relative">
      {/* Slider */}
      <div ref={sliderRef} className="keen-slider rounded-lg overflow-hidden shadow">
        {images.map((img, idx) => (
          <div key={idx} className="keen-slider__slide">
            <img
              src={`${url}${img.url}`}
              alt={img.title || `Slide ${idx + 1}`}
              className="w-full h-auto object-cover"
            />
          </div>
        ))}
      </div>

      {/* Caption */}
      {images[instanceRef.current?.track.details.slides[0]?.index]?.title && (
        <p className="text-sm text-center text-gray-600 mt-2">
          {images[instanceRef.current?.track.details.slides[0]?.index].title}
        </p>
      )}

      {/* Navigation Arrows */}
      <button
        onClick={() => instanceRef.current?.prev()}
        className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white p-2 rounded-full shadow-md transition"
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
      </button>
      <button
        onClick={() => instanceRef.current?.next()}
        className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white p-2 rounded-full shadow-md transition"
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </button>

      {/* Dots */}
      <div className="flex justify-center gap-1 mt-3">
        {images.map((_, idx) => (
          <button
            key={idx}
            onClick={() => instanceRef.current?.moveToIdx(idx)}
            className={`w-2 h-2 rounded-full transition ${instanceRef.current?.track.details.slides[idx]?.portion === 1
                ? "bg-blue-600"
                : "bg-gray-300"
              }`}
          />
        ))}
      </div>
    </div>
  );
};

export default BlogImageSlider;
